import React, { memo } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Edit2, Trash2, FileText, User } from "lucide-react";
import "./ProjectCard.css";

const ProjectCard = memo(
  ({ project, onDelete, onClick, basePath = "/admin" }) => {
    const truncateDescription = (text, maxLength = 100) => {
      if (!text) return "No description available";
      return text.length > maxLength
        ? `${text.substring(0, maxLength)}...`
        : text;
    };

    const handleClick = (e) => {
      if (!e.target.closest(".actions")) {
        onClick(project.id, e);
      }
    };

    return (
      <div className="project-card" onClick={handleClick}>
        <h3>{project.project_details.projectName || "Unnamed Project"}</h3>
        <p>{truncateDescription(project.project_details.description)}</p>
        <div className="project-meta">
          <span className={`status ${project.status}`}>{project.status}</span>
          <span>
            <User size={16} /> {project.user_name || "Unknown User"}
          </span>
        </div>
        <div className="actions">
          <Link
            to={`${basePath}/projects/${project.project_id}`}
            className="view-btn"
          >
            <FileText size={16} />
          </Link>
          <Link
            to={`${basePath}/projects/${project.project_id}/edit`}
            className="edit-btn"
          >
            <Edit2 size={16} />
          </Link>
          <button
            onClick={() => onDelete(project.project_id)}
            className="delete-btn"
          >
            <Trash2 size={16} />
          </button>
        </div>
      </div>
    );
  }
);

ProjectCard.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    status: PropTypes.string.isRequired,
    username: PropTypes.string,
    project_details: PropTypes.shape({
      projectName: PropTypes.string,
      description: PropTypes.string,
    }).isRequired,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ProjectCard;
